import formatString from 'format-string-by-pattern';
import { ReactNode } from 'react';

export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function lowercaseFirstLetter(string: string): string {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export const formatSSNInput = (inputValue: string): string => {
  return inputValue ? formatString('999-99-9999', inputValue.replace(/[^0-9]/g, '')) : '';
};

export const formatFloatInput = (inputValue: string, precision?: number, maxValue?: number): string => {
  let formattedValue = inputValue ? inputValue.replace(/[^0-9.]/g, '').replace(/\.+/, '.') : '';

  // cut to precision
  if (formattedValue && precision && formattedValue.split('.')[1]?.length > precision) {
    formattedValue = formattedValue.substring(0, formattedValue.length - 1);
  }

  // limit to maxValue
  if (formattedValue && maxValue && !formattedValue.endsWith('.') && parseFloat(formattedValue) > maxValue) {
    formattedValue = maxValue.toString();
  }

  return formattedValue;
};

export const formatPhoneInput = (inputValue: string): string => {
  return inputValue ? formatString('(999) 999-9999', inputValue.replace(/[^0-9]/g, '')) : '';
};

export const formatPostalCodeInput = (inputValue: string): string => {
  const POSTAL_CODE_LENGTH = 5;

  let formattedValue = inputValue ? inputValue.replace(/[^\d]/g, '') : '';
  if (formattedValue.length > POSTAL_CODE_LENGTH) {
    return formattedValue.slice(0, -1);
  }
  return formattedValue;
};

export const formatMinMaxValue = (inputValue: string, minValue: number, maxValue: number): string => {
  if (inputValue && typeof minValue === 'number' && parseInt(inputValue) < minValue) {
    return minValue.toString();
  }
  if (inputValue && typeof maxValue === 'number' && parseInt(inputValue) > maxValue) {
    return maxValue.toString();
  }
  return inputValue;
};

export const formatTaxID = (value: string): string => formatString('99-9999999', value.replace(/[^\d-() ]/, ''));

export function formatEnumValue(value: string | null): ReactNode {
  if (!value) return null;

  return value
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export const formatCamelCaseToText = (value: string): string => {
  return value
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .trim();
};

export const formatInitials = (inputValue: string): string => {
  return inputValue ? inputValue.toUpperCase() : '';
};
